import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { InputComponent } from '../input/input.component';
import { NgClass, NgForOf, NgIf, NgOptimizedImage, NgStyle } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '../button/button.component';
import { ProgressService } from './service/progress.service';
import { Progress } from './models/interfaces/progress.interface';
import { Disabled } from '../../directives/disabled/disabled.directive';

@Component({
    selector: 'l-progress',
    templateUrl: './progress.component.html',
    imports: [
        IconComponent,
        ReactiveFormsModule,
        ButtonComponent,
        NgStyle,
        Disabled
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressComponent {

  constructor(
    private readonly progressService: ProgressService
  ) { }

  public progress: Signal<Progress[]> = this.progressService.progress;

  public open: boolean = true;

  public cancel(p: Progress): void {
    if (p.canceled || !p.cancel)
      return;

    p.canceled = true;
    p.cancel();
  }

}
